module.exports = __webpack_public_path__ + "static/img/person_4.a369f43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/person_4.jpg
// module id = F0ep
// module chunks = 1